import React from "react";
import { Card, Row } from "antd";
import PrimaryButton from "../Buttons/PrimaryButton";
import quantity from "../../assets/icons/quantity-icon.svg";
import date from "../../assets/icons/date-time-icon.svg";
import money from "../../assets/icons/money-icon.svg";
import { getCardItem } from "../../components/utils/utils";

interface ServiceCardProps {
  card: any;
  index: number;
  open: any;
}

const ServiceCard = ({ card, index, open }: ServiceCardProps) => {
  const colors = ["#1f3d60", "#029daf", "#04bb96"];

  return (
    <Card className="takaful--service-card-container">
      <div
        className={`takaful--service-card-title-grand`}
        style={{ backgroundColor: colors[index % 3] }}
      >
        <span>{card?.assistance_id}</span>
      </div>
      <div className="takaful--service-card-image-container">
        <img
          src={card?.image_banner_ids}
          alt="service"
          className="takaful--service-card-image"
        />
      </div>

      <Row>
        <h3 className="takaful--service-card-title">{card?.name}</h3>
      </Row>

      {card.type === "product"
        ? getCardItem(
            "الكمية المسموح طلبها",
            card?.allowed_quantity,
            card?.uom_id,
            quantity
          )
        : getCardItem("القيمة المالية", card?.amount, "ريال", money)}

      {getCardItem(
        "الأيام المتبقية للترشح",
        card?.remaining_duration,
        "يوم",
        date
      )}

      <PrimaryButton
        title="الترشح"
        style={{ width: "100%", marginTop: "1rem" }}
        onClick={open}
        disabled={card?.is_registered}
      />
    </Card>
  );
};

export default ServiceCard;
